"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _SearchV = _interopRequireDefault(require("@insided/destination/icons/SearchV2"));

var _Search = _interopRequireDefault(require("./Search"));

var _classnames = _interopRequireDefault(require("classnames"));

var _preactCompat = require("preact-compat");

var _SearchShortcut = _interopRequireDefault(require("./SearchShortcut.util"));

var _excluded = ["showSearch"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CollapsedSearch = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(CollapsedSearch, _PureComponent);

  var _super = _createSuper(CollapsedSearch);

  function CollapsedSearch() {
    var _this;

    (0, _classCallCheck2.default)(this, CollapsedSearch);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "showSearchFn", function () {
      _this.props.onShow();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "outsideClickHandler", function () {
      var _this$props$callbackO, _this$props;

      (_this$props$callbackO = (_this$props = _this.props).callbackOnOutsideClick) === null || _this$props$callbackO === void 0 ? void 0 : _this$props$callbackO.call(_this$props);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyPress", function (event) {
      if (_SearchShortcut.default.isShortcutPressed(event)) {
        _this.showSearchFn();

        event.preventDefault();
        event.stopPropagation();
      }
    });
    return _this;
  }

  (0, _createClass2.default)(CollapsedSearch, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      document.addEventListener('keydown', this.handleKeyPress);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyPress);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          showSearch = _this$props2.showSearch,
          searchProps = (0, _objectWithoutProperties2.default)(_this$props2, _excluded);
      return (0, _preact.h)("div", {
        className: "collapsed-search-wrapper"
      }, !showSearch && (0, _preact.h)("button", {
        className: (0, _classnames.default)('btn', 'btn--secondary', 'btn-show-search'),
        onClick: this.showSearchFn,
        "data-track-type": "click",
        "data-element-name": "Search Button"
      }, (0, _preact.h)(_SearchV.default, {
        width: 18,
        height: 18
      })), (0, _preact.h)("div", {
        className: "search-wrapper",
        hidden: !showSearch
      }, (0, _preact.h)(_Search.default, (0, _extends2.default)({}, searchProps, {
        callbackOnOutsideClick: this.outsideClickHandler
      }))));
    }
  }]);
  return CollapsedSearch;
}(_preactCompat.PureComponent);

exports.default = CollapsedSearch;